import { combineReducers } from 'redux';
import { CALENDAR_SLICE_NAME, calendarReducer } from './calendar';
import { OCCUPANCY_SLICE_NAME, occupancyReducer } from './occupancy';
import { VOUCHER_SLICE_NAME, voucherReducer } from './voucher';

export const datesReducer = combineReducers({
    [VOUCHER_SLICE_NAME]: voucherReducer,
    [OCCUPANCY_SLICE_NAME]: occupancyReducer,
    [CALENDAR_SLICE_NAME]: calendarReducer,
});
